import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { fields } from "./constants";
import { useAddContactDirectory } from "./ContactDirectory.hook";

export const AddNewCD = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editGallery,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditGallery,
  } = useAddContactDirectory(query.get("editId") || "");

  const {
    data: GalleryById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditGallery();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
      name: GalleryById ? decodeHTML(GalleryById.payload.name) : editGallery ? decodeHTML(editGallery?.[0]?.name) : "",
      field_department_name_ms: GalleryById
        ? decodeHTML(GalleryById.payload.field_department_name_ms)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_department_name_ms)
          : "",
      field_department_name_zh: GalleryById
        ? decodeHTML(GalleryById.payload.field_department_name_zh)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_department_name_zh)
          : "",
      field_department_published: GalleryById
        ? GalleryById.payload.field_department_published
        : editGallery
          ? editGallery?.[0]?.field_department_published
          : "",
    },
    fields: fields.addcontactdirectory,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    let publishKey: any = ["field_department_published"];
    for (const key of publishKey) {
      data[key] = !!data[key];
    }

    const payload = {
      action: action,
      method: method,
      module: "Contact Directory",
      subModule: "addcontactdirectory",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Contact Directory`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) => {
          const cdId = query.get("cdId");
          const editId = query.get("editId");
          const isUpdate = editId || query.get("type") === "update" || cdId;

          const apiUrl = cdId
            ? `${magpHost}/api/contactdirectorydepartment/${cdId}`
            : editId || query.get("type") === "update"
              ? `${magpHost}/api/contactdirectorydepartment${
                  editGallery?.[0]?.id || GalleryById?.payload?.id
                    ? `/${editGallery?.[0]?.id || GalleryById?.payload?.id}`
                    : ""
                }`
              : `${magpHost}/api/create/contactdirectorydepartment`;

          onSubmit(
            data,
            apiUrl,
            isUpdate ? "UPDATE" : "CREATE",
            isUpdate ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          );
        }}
      />
    </ContentWrapper>
  );
};
